export var RESOLVE_METHOD = /*#__PURE__*/function (RESOLVE_METHOD) {
  RESOLVE_METHOD["COMPONENT"] = "component";
  RESOLVE_METHOD["CONSUMER"] = "consumer";
  RESOLVE_METHOD["ORPHANED"] = "orphaned";
  return RESOLVE_METHOD;
}({});